import React, { useState, useEffect } from "react";
import "./thankyouPage.css";
import Header from "../components/common/header";
import Footer from "../components/common/footer";
import selsmartLogo from "../../assets/images/selsmart.png";
import { useExchangeUser } from "../../contexts/userExchangeProgramContext";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

const ThankyouPage = () => {
  const {
    setOrderId,
    setUserId,
    setServicablePincode,
    setBasePrice,
    setOldProduct,
    setCustInfo,
  } = useExchangeUser();
  const [reload,setReload] = useState(false);
  const location = useLocation()
  const params = useParams()
  const orderNumber = location.state?.orderNumber;
  // //console.log(location.state)
  const navigate = useNavigate()
  const prog_id = location.state?.prog_id
  // const prog_id = params.prog_id
  // //console.log("thank you page navigate prog id",prog_id)

  localStorage.removeItem("exchange_order_id");
  localStorage.removeItem("exchange_user_id");
  localStorage.removeItem("exchange_servicable_pincode");
  localStorage.removeItem("exchange_selected_old_product");
  localStorage.removeItem("exchange_base_price");
  localStorage.removeItem("exchange_cust_info");
  sessionStorage.removeItem('mobile_no');
  setOrderId(null);
  setUserId(null);
  setServicablePincode(null);
  setBasePrice(null);
  setOldProduct(null);
  setCustInfo(null);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const version = process.env.REACT_APP_VERSION;

  useEffect(() => {
    fetchSeoMetaDetails()
  },[]);

const fetchSeoMetaDetails = async () => {
    try {
        const code = 'exchange_thankyou_page'
        const response = await fetch(`${backendUrl}${version}seo-meta-details/${code}`,
          {  method: 'GET',
            headers:{
              // Accept:'aplication/json',
              "Content-Type": "application/json",
      
            },
            credentials: "include",
            mode:"cors"                
          }
        );
        if (!response.ok) throw new Error('Failed to fetch categories');
        const data = await response.json();
        await changeTitleAndMetaTags(data.result.page_title, {description:data.result.meta_description,keywords:data.result.meta_tag});
    } catch (error) {
        //console.error('Error fetching categories:', error);
    }
  };
  
  const changeTitleAndMetaTags = async (
    title: string,
    metaTags: { description?: string; keywords?: string; [key: string]: string | undefined }
  ) => {
    try {
        // Update the document title
        if (title) {
            document.title = title;
        } else {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
        }
  
        // Update or create meta tags
        Object.keys(metaTags).forEach((metaName) => {
            const metaTag = document.querySelector(`meta[name="${metaName}"]`);
            if (metaTag) {
                // Update existing meta tag
                metaTag.setAttribute('content', metaTags[metaName] || `Default ${metaName} for Selsmart`);
            } else {
                // Create new meta tag if it doesn't exist
                const newMetaTag = document.createElement('meta');
                newMetaTag.name = metaName;
                newMetaTag.content = metaTags[metaName] || `Default ${metaName} for Selsmart`;
                document.head.appendChild(newMetaTag);
            }
        });
  
        // Cleanup function to reset the title and meta tags when unmounting
        return () => {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
            Object.keys(metaTags).forEach((metaName) => {
                const metaTag = document.querySelector(`meta[name="${metaName}"]`);
                if (metaTag) {
                    metaTag.setAttribute('content', `Default ${metaName} for Selsmart`);
                }
            });
        };
    } catch (error) {
        //console.error("Error updating title and meta tags:", error);
    }
  };
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      // Warn the user before navigating away
      event.preventDefault();
      event.returnValue = ""; // Required to trigger the browser's confirmation dialog
      // navigate("/exchange/program/49203c92bdbc3e15893a15779e5d1b34");
      setReload(true);
    };

    const handleUnload = () => {
      // Redirect user programmatically
      // navigate("/exchange/program/49203c92bdbc3e15893a15779e5d1b34");
      //console.log("Navigating to specific page on unload");
    };

    // Add event listeners
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("unload", handleUnload);
    setTimeout(() => {
      navigate(`/exchange/program/${prog_id}`);
    }, 90000);
    // Cleanup event listeners
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("unload", handleUnload);
    };
    
  }, []);

  // useEffect(() => {
  //   //console.log("reload data", reload)
  //   if (reload) { navigate(`/exchange/program/${prog_id}`); }
  // },[reload])

  return (
    <div>
      <Header />
      <main className="main-content-thank-you-page container">
        <div className="thank-you-page">
          <h3>Form Submitted Successfully!</h3>
          <p className="order-number">Reference Order Number: <strong>{orderNumber}</strong> </p>
          <p className="thank-you-content-one">
            Thank you for participating in Daikin Green Exchange Program.
          </p>
          <p className="thank-you-content">
            Your order has been successfully placed and scheduled for pickup
          </p>
          <p className="thank-you-content">
            Your Order Number has been sent via SMS to your Mobile Number and
            Email Id.
          </p>
          <p className="thank-you-content-two">
            Please Do not place a separate installation request against the
            purchase of New Daikin AC.
          </p>
          <p className="thank-you-content-three">
            For assistance or inquiries related to Daikin Green Exchange Program
            or Old AC pickup, please contact our customer care at{" "}
            <a href="tel:9355541464">9355541464</a>.
          </p>
          <p className="thank-you-content-three">
            For assistance or inquiries related to New Daikin AC, please contact
            Daikin customer care.
          </p>
          <div>
            <Link to="/">
              <img
                className="logo"
                src={selsmartLogo}
                alt="Daikin Home Banner"
              />
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ThankyouPage;
